module.exports = __webpack_public_path__ + "img/logo.59bfad9e.png";